import { css, Theme } from '@emotion/react';

export const inputBaseStyles = (theme: Theme, isError?: boolean) => css`
	box-sizing: border-box;
	width: 100%;
	height: ${theme.ui.form.controlHeight};
	padding: 0 ${isError ? '4rem' : theme.ui.form.controlPaddingX};
	border: 1px solid ${isError ? theme.colors.red600 : theme.ui.border.strong};
	border-radius: ${theme.ui.form.controlRadius};
	background-color: ${theme.ui.surface.page};
	color: ${theme.ui.text.primary};
	font-size: ${theme.fontSize.sizeMd};
	font-weight: ${theme.fontWeight.weightRegular};
	line-height: 1.4;
	letter-spacing: ${theme.ui.letterSpacing.body};
	transition:
		border-color ${theme.effects.transitionFast},
		box-shadow ${theme.effects.transitionFast},
		background-color ${theme.effects.transitionFast};

	&::placeholder {
		color: ${theme.ui.text.muted};
	}

	&:hover:not(:disabled):not(:read-only) {
		border-color: ${theme.colors.primary200};
	}

	&:focus {
		outline: none;
		border-color: ${theme.ui.interactive.primary};
		box-shadow: 0 0 0 3px ${theme.ui.interactive.focusRing};
	}

	&:disabled,
	&:read-only {
		background-color: ${theme.ui.surface.subtle};
		border-color: ${theme.ui.border.default};
		color: ${theme.ui.text.muted};
		cursor: not-allowed;
	}
`;

export const selectBaseStyles = (theme: Theme) => css`
	box-sizing: border-box;
	width: 100%;
	height: ${theme.ui.form.controlHeight};
	padding: 0 ${theme.ui.form.controlPaddingX};
	border: 1px solid ${theme.ui.border.strong};
	border-radius: ${theme.ui.form.controlRadius};
	background-color: ${theme.ui.surface.page};
	color: ${theme.ui.text.primary};
	font-size: ${theme.fontSize.sizeMd};
	font-weight: ${theme.fontWeight.weightRegular};
	line-height: 1.4;
	letter-spacing: ${theme.ui.letterSpacing.body};
	cursor: pointer;
	transition:
		border-color ${theme.effects.transitionFast},
		box-shadow ${theme.effects.transitionFast};

	&:hover:not(:disabled) {
		border-color: ${theme.colors.primary200};
	}

	&:focus {
		outline: none;
		border-color: ${theme.ui.interactive.primary};
		box-shadow: 0 0 0 3px ${theme.ui.interactive.focusRing};
	}

	&:disabled {
		background-color: ${theme.ui.surface.subtle};
		border-color: ${theme.ui.border.default};
		color: ${theme.ui.text.muted};
		cursor: not-allowed;
	}
`;

export const textareaBaseStyles = (theme: Theme, isError?: boolean) => css`
	box-sizing: border-box;
	width: 100%;
	min-height: 20rem;
	padding: 1.6rem;
	border: 1px solid ${isError ? theme.colors.red600 : theme.ui.border.strong};
	border-radius: ${theme.ui.form.controlRadius};
	background-color: ${theme.ui.surface.page};
	color: ${theme.ui.text.primary};
	font-size: ${theme.fontSize.sizeMd};
	font-weight: ${theme.fontWeight.weightRegular};
	line-height: 1.5;
	letter-spacing: ${theme.ui.letterSpacing.body};
	resize: vertical;
	transition:
		border-color ${theme.effects.transitionFast},
		box-shadow ${theme.effects.transitionFast};

	&::placeholder {
		color: ${theme.ui.text.muted};
	}

	&:focus {
		outline: none;
		border-color: ${theme.ui.interactive.primary};
		box-shadow: 0 0 0 3px ${theme.ui.interactive.focusRing};
	}
`;
